import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#featured', label: '热门佳作' },
  { href: '#genres', label: '主题分类' },
  { href: '#toplist', label: '本期清单' },
  { href: '#reviews', label: '漫友评价' },
  { href: '#faq', label: '常见问题' },
  { href: '#about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/90 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <a
          href="#top"
          className={`font-heading text-xl tracking-wide transition-colors ${
            solid ? 'text-primary-600' : 'text-background-50'
          }`}
        >
          178漫画网
        </a>

        <div className={`hidden md:flex items-center gap-1 ${solid ? '' : 'text-background-50'}`}>
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                solid ? 'text-foreground-700 hover:bg-background-100' : 'text-background-50/90 hover:bg-white/10'
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#submit"
            className="hidden md:inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-quill-pen-fill" aria-hidden="true"></i>
            投稿安利
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            aria-expanded={open}
            className={`inline-flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
              solid ? 'text-foreground-900' : 'text-background-50'
            }`}
          >
            <i className={`text-xl ${open ? 'ri-close-line' : 'ri-menu-line'}`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="flex flex-col gap-1 px-4 py-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              投稿安利
            </a>
          </div>
        </div>
      )}
    </header>
  );
}